import Brett from "./Brett";
import { v3 } from 'oc-threejs/short3';
import Debugs from "oc-threejs/Debugs";
import type { HasLocalCoordinates } from "./HasLocalCoordinates";

export default class Interieur implements HasLocalCoordinates {
    // DO NOT CHANGE
    className = "Interieur";

    id = APP.nextId();

    // persistent (UserLayer) ------------------------------------------

    // die untere Seite der box
    // ACHTUNG! Weil y ein aus size und position abgeleiteter Wert ist,
    // verändert eine einseitige Änderung der Size auch y!
    get y() {
        return Debugs.checkNaN(this.position.y - this.size.y / 2);
    }

    set y(v) {
        this.position.y = Debugs.checkNaN(v + this.size.y / 2)
    }

    product: ?Object;
    type: string;
    flipSide = 0;
    size = v3();

    // transient (CompiledLayer) ---------------------------------------

    element: ?Object;
    object3d: ?THREE.Object3D;
    minSize = new THREE.Vector3();
    maxSize = new THREE.Vector3();
    needsBoden = {
        top: false,
        bottom: false,
    };
    bohrlochleiste = null;
    // eine Map Dekortyp -> Material.Name. Fallback ist materials eines Parents.
    // materials = {};

    // Wenn true hat dieses Interieur keine Interaktionen im 3D (tapable, draggable und hoverable)
    disableInteraction = false;

    // true falls dieses Interieur gerade gedraggt wird. Wichtig für manche Validierung
    get dragging() {
        return this.object3d && this.object3d.dragging;
    }

    get schrank() {
        return this.element ? this.element.schrank : APP.model.currentSchrank;
    }

    get arrangement() {
        return this.schrank.arrangement;
    }

    // gibt die für das Interieur gültige Box des Elementes zurück. Entweder element.box oder element.unverdeckt.box
    getElementBox(element) {
        return element.box;
    }

    // Interieur, welches auf der Linken oder Rechten Seite eines Elements angebracht wird,
    // hat canFlip=true. flipSide=0 links, =1 rechts
    canFlip = false;

    // Für Türen darf boden.top trotz needsBoden.top==true null sein im Falle von Dachschrägen
    boden = {
        top: null,
        bottom: null,
    };

    // Mindest-Freiraum über/unter der Box
    space = {
        top: 0,
        bottom: 0,
    };

    // die Box im lokalen System des Parents
    box = new THREE.Box3();

    // die Box im lokalen System des Schranks
    schrankBox = new THREE.Box3();

    // optionale Union-Box der Fronten im lokalen Koordinatensystem des Interieurs
    frontBox: ?THREE.Box3;

    // Box im lokalen Koordinatensystem des Interieurs mit Ursprung links unten hinten
    get boxLocal() {
        return new THREE.Box3(v3(), this.size.clone());
    }

    // Box inklusiv Freiraum (mindestens Fachhöhe) für Validierung der Höhe des Elements
    getSpaceBoxForValidation() {
        const boden_hoehe = this.schrank.options.getFloat('brett_staerke');
        const fach_hoehe = this.schrank.options.getFloat('fach_hoehe');
        const b = this.box.clone();
        if (!this.boden.bottom) {
            b.min.y -= Math.max(this.space.bottom, this.needsBoden.bottom ? fach_hoehe + boden_hoehe : 0);
        }
        if (!this.boden.top) {
            b.max.y += Math.max(this.space.top, this.needsBoden.top ? fach_hoehe + boden_hoehe : 0);
        }
        return b;
    }

    get isShallow() {
        return false;
    }

    canOverlay(other: Interieur) {
        return other === this || (other.isShallow && !this.hasFronts);
    }

    // Position im Schrank-Koordinatensystem, und entspricht dem Center der Box
    position = new THREE.Vector3();

    constructor(type: string, element: ?Object) {
        this.type = type;
        this.element = element;
        this.setFromTypeInterieurJson();
    }

    setFromTypeInterieurJson() {
        const row = APP.metadata.Interieurtypen.find(x => x.Typ == this.type);
        this.size.fromArray(row.Size.split(',').map(x => parseFloat(x)));
        this.needsBoden.top = row.NeedsBodenTop;
        this.needsBoden.bottom = row.NeedsBodenBottom;
        this.canFlip = row.CanFlip || false;
        this.bohrlochleiste = row.Bohrlochleiste || null;
    }

    /**
     * zum Filtern der möglichen Elemente für den Drag-Vorgang
     */
    acceptElement(element) {
        return element.size.x >= this.product.BreiteMin
            && element.size.x <= this.product.BreiteMax
            && element.wallRight && element.wallLeft &&
            !(this.product.EckschrankVerdecktesElementVerboten && (element.verdecktVonElementen.length > 0 || element.verdecktAnderenSchrank))
    }

    // implementation in subclasses
    getPrice() {
        let price = 0.0;

        return Math.round(price);
    }

    toJSON() {
        return {
            className: this.className,
            size: this.size,
            box: this.box,
            schrankBox: this.schrankBox,
            y: this.position.y,
            Artikelnummer: this.artikelnummer,
            InternerName: this.product.InternerName,
            type: this.product.type,
            // materials: _.clone(this.materials),
            flipSide: this.flipSide,
            disableInteraction: this.disableInteraction
        }
    }

    get artikelnummer() {
        return this.product ? this.product.Artikelnummer : null;
    }

    fromJSON(json) {
        this.product = APP.findProduct(json.Artikelnummer);
        this.position.y = json.y;
        this.size = v3().fromJSON(json.size);
        this.flipSide = json.flipSide || 0;
        // _.assign(this.materials,json.materials);
        // APP.healMaterials(this.materials,true);
        this.disableInteraction = json.disableInteraction;
        return this;
    }

    copy(interieur, createInterceptor) {
        this.id = interieur.id;
        this.position.copy(interieur.position);
        this.product = interieur.product;
        if (this.product == null) {
            debugger;
        }
        this.type = interieur.type;
        this.size.copy(interieur.size);
        this.flipSide = interieur.flipSide;
        // _.assign(this.materials,interieur.materials);
        return this;
    }

    compileSizeAndBox() {
        this.minSize.set(this.product.BreiteMin || 0, this.size.y, this.product.TiefeMin || 0);
        this.maxSize.set(this.product.BreiteMax == null ? Number.POSITIVE_INFINITY : this.product.BreiteMax, this.size.y, this.product.TiefeMax == null ? Number.POSITIVE_INFINITY : this.product.TiefeMax);
        this.space.top = this.product.FreiraumOben;
        this.space.bottom = this.product.FreiraumUnten;
        this._compileSize();
        this._compileBox();
    }

    compileInternals() {
        APP.model.lazyCreateObject3d(this, () => {
            const object = APP.model.createObject3D(this);
            (this.parent == null ? this.schrank : this.parent).child3dContainer.add(object);
            return object;
        });
        this._validate();
    }

    _compileBox() {
        if (this.element) {
            this.element.centerInterieurXZ(this);
        }
        this.box.setFromCenterAndSize(this.position, this.size);
        if (this.element) {
           
            this.schrankBox.min = this.element.localToSchrank(this.box.min);
            this.schrankBox.max = this.element.localToSchrank(this.box.max);
        }
       
    }

    _validate() {
        if (!this.element) {
            return;
        }

        const epsilon = 0.0002;
        const elementBox = this.getElementBox(this.element)
        const elementSize = elementBox.getSize();
        if (elementSize.x > this.product.BreiteMax + epsilon) {
            APP.model.maybeThrowCompileError(this, 'compileError', 'dialogInteriorMaxWidth', this.product.Name, this.product.BreiteMax, elementBox, elementSize.x);
        } else if (elementSize.x < this.product.BreiteMin - epsilon) {
            APP.model.maybeThrowCompileError(this, 'compileError', 'dialogInteriorMinWidth', this.product.Name, this.product.BreiteMin, elementBox, elementSize.x);
        } else if (elementSize.z < this.product.TiefeMin - epsilon) {
            // Wenn wir in der Meldung die TiefeMin ausgeben, dann versteht der Nutzer die Welt nicht.
            // Die Kleiderstange hat eine TiefeMin von 40cm. Der Nutzer stellt den Schrank auf 40cm Tiefe und kriegt die Meldung: Die minimale Tiefe beträgt 40cm. ???
            // Daher rechnen wir hier die TiefeMin heuristisch auf die Schrank(aussen)tiefe um.
            // Ist nicht ganz richtig für DSH.
            const schrankTiefeMin = this.product.TiefeMin + this.schrank.options.getFloat('rueckwand_vorsprung') + this.schrank._getFrontOffset();
            APP.model.maybeThrowCompileError(this, 'compileError', 'dialogInteriorMinDepth', this.product.Name, schrankTiefeMin);
        }

        if (this.element.sloped && !this.canTopBeSlopedInElement(this.element)) {
            const brettstaerke = this.schrank.options.getFloat('brett_staerke');

            if (this.schrank.angleSide === 'left' && this.box.max.y > (this.schrank.slopings.yOfX(this.box.min.x, brettstaerke) + epsilon)) {
                APP.model.maybeThrowCompileError(this, 'compileError', 'dialogInteriorInSlopedElement', this.product.Name, this.product.BreiteMin);
            } else if (this.schrank.angleSide === 'right' && this.box.max.y > (this.schrank.slopings.yOfX(this.box.max.x, brettstaerke) + epsilon)) {
                APP.model.maybeThrowCompileError(this, 'compileError', 'dialogInteriorInSlopedElement', this.product.Name, this.product.BreiteMin);
            } else if (this.schrank.angleSide === 'back') {
                const depth = this.element.box.max.z - this.schrank.slopings.elementZofY(this.box.max.y);
                if (depth < this.product.TiefeMin && this.product.type !== 'Tuer') {
                    APP.model.maybeThrowCompileError(this, 'compileError', 'dialogInteriorMinDepth', this.product.Name, this.product.TiefeMin);
                }
            }
        }

        /* if (this.product.EckschrankVerdecktesElementVerboten && (this.element.verdecktVonElementen.length > 0 || this.element.verdecktAnderenSchrank)) {
            APP.model.maybeThrowCompileError(this, 'compileError', 'interieurNotAllowedInHiddenElement', this.product.Name);
        } */

        if (this.element.getNumberOfParentElements() > 0) {
            if (this.schrankBox.min.y + epsilon < this.parent.schrankBox.min.y) {
                APP.model.maybeThrowCompileError(this, 'compileError', 'dialogInteriorPositionOutOfElement', this.schrankBox.min.y, this.parent.schrankBox.min.y);
            }
            if (this.schrankBox.max.y > this.parent.schrankBox.max.y + epsilon) {
                APP.model.maybeThrowCompileError(this, 'compileError', 'dialogInteriorPositionOutOfElement', this.schrankBox.max.y, this.parent.schrankBox.max.y);
            }
        }

        if (this.schrank.isSchwebetuer && this.canFlip && this.element) {
            const interieurSide = this.flipSide === 0 ? 'wallLeft' : 'wallRight';
            const isAllowed = (
                (this.element[interieurSide].isInner && this.element[interieurSide].product.Artikelnummer === 'Trennwand') ||
                (!this.element[interieurSide].isInner && this.element[interieurSide].product.Artikelnummer !== 'Trennwand')
            );
            if (!isAllowed) {
                this.flipSide = this.flipSide === 0 ? 1 : 0;
            }
        }
    }

    _compileSize() {
        if (this.element) {
            const elementBox = this.getElementBox(this.element);
            
            this.size.x = elementBox.getSize().x;
            this.size.z = elementBox.max.z// - this.element.getInterieurMinZ(this.y, this.y + this.size.y);         
        }
    }

    getHeight(bottom: boolean, top: boolean) {
        return this.size.y;
    }

    compileFront() {
    }

    get hasFronts() {
        return false;
    }

    addToElement(element) {
        this.element = element;
        this.element.interieurs.push(this);
        APP.model.setDirty();
    }

    getSide() {
        return this.product.Typ === 'Tuer' && this.product.Art.split(':')[0];
    }

    getFrontOffset() {
        return 0;
    }

    ownsBoden(boden: Brett) {
        return boden.interieurCount === 1 && this.hasBoden(boden);
    }

    hasBoden(boden: Brett) {
        return boden === this.boden.top || boden === this.boden.bottom;
    }

    get child3dContainer() {
        return this.object3d.boxLocalO3;
    }

    schrankToLocal(v: THREE.Vector3) {
        return this.element ? this.element.schrankToLocal(v).sub(this.box.min) : v.clone();
    }

    localToSchrank(v: THREE.Vector3) {
        return this.element ? this.element.localToSchrank(v).add(this.box.min) : v.clone();
    }

    // die Mitte (y) in Schrank-Koordinaten
    setSchrankPositionY(y) {
        this.position.y = this.parent ? this.parent.schrankToLocal(v3(0, y, 0)).y : y;
    }
    getSchrankPositionY() {
        return this.parent ? this.parent.localToSchrank(this.position).y : this.position.y;
    }

    // die untere Kante (y) in Schrank-Koordinaten
    setSchrankY(y) {
        this.y = this.parent ? this.parent.schrankToLocal(v3(0, y, 0)).y : y;
    }

    getSchrankY() {
        return this.parent ? this.parent.localToSchrank(v3(0, this.y, 0)).y : this.y;
    }

    /**
     * Der Überstand einer Front hängt ab von:
     * - Aussen/Innenwand
     * - Aufschlagende/Einschlagende Konstruktion
     */
    getFrontUeberstand(brett, minMax, axis) {
        const fuge = this.schrank.options.getFloat('fugen_abstand');
        const aufschlagend = this.schrank.options.getFloat('aussenwand_vorsprung') == 0.0;
        if (aufschlagend || brett.isInner) {
            const offsets = {
                'min': { 'x': 'ueberstand_aussen_seite', 'y': 'ueberstand_aussen_unten', 'z': null },
                'max': { 'x': 'ueberstand_aussen_seite', 'y': 'ueberstand_aussen_oben', 'z': null },
            };
            const pointInSchrank = brett.parent.localToSchrank(brett.isInner ? brett.box.getCenter() : brett.box[minMax]);
            const offset = brett.isInner ? fuge * 0.5 : this.schrank.options.getValue(offsets[minMax][axis]);
            return this.schrankToLocal(pointInSchrank)[axis] + offset * (minMax === 'min' ? +1 : -1);
        } else {
            const pointInSchrank = brett.parent.localToSchrank(brett.box[minMax == 'min' ? 'max' : 'min']);
            if (minMax === 'min' && axis === 'y') {
                return this.schrankToLocal(pointInSchrank)[axis] - brett.size.y * (minMax === 'min' ? +1 : -1);
            }
            return this.schrankToLocal(pointInSchrank)[axis] + fuge * (minMax === 'min' ? +1 : -1);
        }
    }

    removeFromElement() {
        if (this.element == null) {
            return;
        }
        this.element.interieurs = this.element.interieurs.filter(x => x !== this);
        this.element = null;
        APP.model.setDirty();
    }

    canTopBeSlopedInElement(element) {
        return false;
    }

    /**
     * ist false, falls dieses Objekt Teil des this.arrangement ist.
     */
    isOrphaned() {
        if (this.element == null) {
            return true;
        }
        if (!this.element.interieurs.includes(this)) {
            return true;
        }
        return this.element.isOrphaned();
    }

    iterateElements(iterator) {
    }

    get parent() {
        return this.element;
    }

    isChildOf(parent) {
        return this.parent !== null && (this.parent === parent || this.parent.isChildOf(parent));
    }
    
    iterate(iterator) {
        iterator(this);
    }

    getBox3World(box) {
        let schrank = this.schrank;
        let myBox = box.clone();
        if (this.element.getNumberOfParentElements() > 0) {
            schrank = this.parent.schrank;
        }
        const finalBox = schrank.localToWorldBox(myBox).heal();
        return finalBox;
    }

}
